/**
 * App Redux Action Types
 */
// Auth Actions
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGOUT_USER = 'LOGOUT_USER';
export const UPDATE_USER_INFO = 'UPDATE_USER_INFO';
export const UPDATE_COMPANY = 'UPDATE_COMPANY';
export const UPDATE_SITE_SETTING = 'UPDATE_SITE_SETTING';